<template>
  <div>
    <xiaoqu    > </xiaoqu> 
    <!-- mac_manage_flag 用于下级页面接收的参数 -->
  </div>
</template>
<script>
import xiaoqu from '../../tongyong/xiaoqu.vue';
 
export default {

  components: {
    xiaoqu: xiaoqu 
  },

  data() {
    return {
      // 获取用户列表参数
      
    };
  },
  props: [],
 
  watch: {
 
  },
  created() {
 
  },
  mounted() {
 
  }
}
</script>
